module.exports = __webpack_public_path__ + "img/Edit.f732fc34.svg";